import {loginApi, userInfoApi} from '@/api/user/index'
import {removeToken} from '@/auth/auth'
// initial state
const state = {
  userInfo: {}
}

// getters
const getters = {
  userInfo: state => state.userInfo
}

// actions
const actions = {
  // 登录
  loginAction ({commit}, loginData) {
    return new Promise((resolve, reject) => {
      loginApi(loginData).then(response => {
        if (response.status === '2000') {
          commit('setUserInfo', response.data)
          resolve()
        } else if (response.status === '6666') {
          reject(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取登录用户信息
  getUserInfoAction ({commit}) {
    return new Promise((resolve, reject) => {
      userInfoApi().then(response => {
        if (response.status === '2000') {
          if (response.data) {
            commit('setUserInfo', response.data)
          }
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 登出
  logOutAction ({commit}) {
    return new Promise((resolve, reject) => {
      removeToken()
      commit('setUserInfo', {})
      resolve()
    })
  }
}

// mutations
const mutations = {
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js